// extracted by mini-css-extract-plugin
module.exports = {"custonCheckbox":"EnableAlisaField_custonCheckbox__3tDST"};